<app-admin-sidebar></app-admin-sidebar>
<app-adminheader></app-adminheader>
<div class="dash">
  <div class="trip-acoordion">
    <div class="dash-trucks-top" *ngIf="DeleteAction">
      <span>Selected: {{ SelectedItems }}</span>
    </div>
    <div class="dash-trucks-top1">
      <a [ngClass]="{ active: truckType == '-1' }" (click)="getTripsList('-1')"
        >All</a
      >
      <a
        [ngClass]="{ active: truckType == 'allocated' }"
        (click)="getTripsList('allocated')"
        >Allocated</a
      >
      <a
        [ngClass]="{ active: truckType == 'available' }"
        (click)="getTripsList('available')"
        >Available</a
      >
      <a
        [ngClass]="{ active: truckType == 'under_verification' }"
        (click)="getTripsList('under_verification')"
        >Under Verification</a
      >
      <a
        [ngClass]="{ active: truckType == 'maintenance' }"
        (click)="getTripsList('maintenance')"
        >Maintenance</a
      >
    </div>
    <div class="dash-trucks-top2">
      <button
        *ngIf="addBtn"
        type="button"
        class="button buttonBlue fixed-btn"
        (click)="trucksAdd()"
      >
        <img class="trucks-head-img" src="../../../assets/img/plus-white.svg" />
        Add
      </button>
      <button
        type="button"
        class="button delete-btn fixed-btn m-rl"
        *ngIf="truckSelect"
        (click)="selectTruck()"
      >
        <img
          class="trucks-head-img"
          src="../../../assets/img/check-circle.svg"
        />
        Select
      </button>
      <button
        type="button"
        class="button delete-btn fixed-btn m-rl"
        *ngIf="truckCancel"
        (click)="cancelTruck()"
      >
        Cancel
      </button>
      <button
        type="button"
        class="button delete-btn fixed-btn m-rl"
        *ngIf="truckDelete"
        (click)="deleteTruck()"
      >
        <img class="trucks-head-img" src="../../../assets/img/delete.svg" />
        Delete
      </button>
      <button
        type="button"
        *ngIf="searchButton"
        class="button search-btn fixed-btn"
        (click)="openSearch()"
      >
        <img src="../../../assets/img/search-white.svg" />
      </button>
      <div *ngIf="toggleSearch" class="search_toggle">
        <input
          uppercase
          class="search pl-2"
          placeholder="Truck no"
          id="truckNumber"
          #newItem
          (input)="onInputChange(newItem)"
          (keyup.enter)="isInputValid && search(newItem.value)"
        />

        <button
          (click)="search(newItem.value)"
          class="search_number"
          *ngIf="search_btn"
          [disabled]="!isInputValid"
        >
          <img src="../../../assets/img/search-white.svg" />
        </button>

        <button *ngIf="clear_btn" class="clear_number" (click)="resetSearch()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            fill="currentColor"
          >
            <path
              d="M5.28 4.22a.75.75 0 0 0-1.06 1.06L6.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L8 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L9.06 8l2.72-2.72a.75.75 0 0 0-1.06-1.06L8 6.94 5.28 4.22Z"
            />
          </svg>
        </button>
      </div>
    </div>
  </div>

  <div class="trucks" *ngIf="trucksAll">
    <div [class.spinner]="loading"></div>

    <div class="row to_container" *ngIf="!trucksArray?.length && !loading">
      <h4 class="error_msg">No Records Found.</h4>
    </div>
    <div class="row">
      <div
        class="col-xl-3 col-lg-4 col-md-6 col-sm-12"
        *ngFor="let item of trucksArray; let i = index"
      >
        <div class="truckscol">
          <mat-checkbox
            *ngIf="checkBox"
            (change)="matItem($event, item._id, i)"
          ></mat-checkbox>
          <div class="otp-field" *ngIf="item.truck_status === 'rejected'">
            <img
              src="../../../assets/img/tick-verify-red.svg"
              class="driver_icon"
            />
          </div>
          <div
            class="otp-field"
            *ngIf="
              item.truck_status === 'available' ||
              item.truck_status === 'allocated'
            "
          >
            <img
              src="../../../assets/img/tick-verify.svg"
              class="driver_icon"
            />
          </div>
          <div
            class="otp-field"
            *ngIf="
              item.truck_status === 'maintenance' ||
              item.truck_status === 'maintanence'
            "
          >
            <img
              src="../../../assets/img/tick-verify-brown.svg"
              class="driver_icon"
            />
          </div>
          <div class="otp-field" *ngIf="item.truck_status === 'trip_booked'">
            <img
              src="../../../assets/img/tick-verify-orange.svg"
              class="driver_icon"
            />
          </div>
          <img src="{{ item.truck_image }}" class="truckImg" />
          <p class="truck-name">{{ item.make_name }}</p>
          <p class="truck-category">
            {{ item.truckTypeInfo[0]?.truck_weight +"," }}
            {{ item.truckTypeInfo[0]?.truck_feet +","  }}
            {{ item.truckTypeInfo[0]?.minimum_amount +" W"+"," }}
            {{ item.truckCategoryInfo[0]?.truck_category_name }}
          </p>
          <p class="truck-number">
            Truck No: {{ item.truck_number | uppercase }}
          </p>
          <p class="truck-insu">
            RC Exp Date: {{ item.rc_valid ? (item.rc_valid | date: 'dd-MM-yyyy') : 'NA' }}
          </p>
          <p class="truck-date">
            Driver Contact No: {{ item.driverInfo[0]?.mobile ?? 'NA' }}
          </p>
          <p class="truck-insu">
            Driver Name:
            {{ item.driverInfo[0]?.username ?? 'NA' }}
          </p>
          <p class="truck-insu">
            Recent Trip: {{ item.tripBookingInfo?.length ? item.tripBookingInfo[0].trip_id + ' - ' + item.tripBookingInfo[0].trip_status : 'NA' }}
          </p>
          <div class="truck-btn">
            <a class="truck-add" (click)="addNotes(item._id)">Add Notes</a>
            <a class="truck-view" (click)="viewTrucks(item)">View</a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="last_page && last_page > 1" class="pagination">
    <button class="btn" [disabled]="fetch_page == 1" (click)="pagination('-1')">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="btn--icon"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M15 19l-7-7 7-7"
        />
      </svg>
    </button>
    <button
      class="btn"
      [disabled]="fetch_page == 1"
      (click)="pagination('first')"
    >
      <img
        src="../../../assets/img/pagination-left.svg"
        alt=""
        class="btn--icon"
      />
    </button>
    <div class="pages">
      <a class="page" *ngIf="fetch_page > 0">{{ fetch_page }}</a>
    </div>
    <button
      class="btn"
      [disabled]="last_page == fetch_page"
      (click)="pagination('last')"
    >
      <img
        src="../../../assets/img/pagination-right.svg"
        alt=""
        class="btn--icon"
      />
    </button>
    <button
      class="btn"
      [disabled]="last_page == fetch_page"
      (click)="pagination('1')"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="btn--icon"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <path
          stroke-linecap=" round"
          stroke-linejoin="round"
          d="M9 5l7 7-7 7"
        />
      </svg>
    </button>
  </div>
</div>
